
import { withTranslation } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import i18n from "i18next";
import {
  HeaderSection,
  MainTopUtility,
  MainTopUtilityRow,
  LangButton,
  LogoContainer,
  SiteControls,
  MainTopNavigation,
  CustomNavLinkSmall,
  Span,
  Section,
  TopnavResponsive, ImgSpan
} from "./styles";
import React, { useContext, useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { LangContext } from "../../context/UserContext";

interface HeaderProps{
  t:any;
  menuShow?:boolean;
} 

const Header = (props: HeaderProps) => {
  const languageCheck: any = useContext(LangContext);
  // Mobile Menu View
  const [isOpen, setIsOpen] = useState(false);
  const toggleClickHandler = () => setIsOpen(!isOpen);
  const items = [
    {   
      itemNo: 0,
      url: "https://www.sab.com/en/personal/ways-to-bank/sab-mobile/",
      title: "HEADER_SAB_MOBILE",
    },
    {
      itemNo: 1,
      url: "https://www.sab.com/en/personal/ways-to-bank/sab-online/",
      title: "HEADER_SAB_ONLINE",
    },
    {
      itemNo: 2,
      url: "https://www.sabb.com/en/business/Home/",
      title: "HEADER_BUSIN_INT_BANKG",
    },
    {
      itemNo: 3,
      url: "https://www.sabb.com/en/contact-us/",
      title: "HEADER_CONT_US",
    },
  ];

useEffect(()=>{
  if(document.body.dir==="rtl"){
    languageCheck.setLanguage(true);
  }else{
    languageCheck.setLanguage(false);
  }
},[])

  const handleChange = () => {
    languageCheck.setLanguage(!languageCheck.language);
    !languageCheck.language?i18n.changeLanguage("ar"):i18n.changeLanguage("en");
    !languageCheck.language?document.documentElement.lang="ar":document.documentElement.lang="en";
    document.body.dir = i18n.dir();

    //change chatbot session
   let botscript= document.getElementById("BotappScript");
    if(botscript){
      botscript.remove();
      let appScript = document.createElement('script');
      appScript.src = "/fonts/chatbot/app.js";
      appScript.type = "text/javascript";
      appScript.id="BotappScript";
      appScript.setAttribute("channelType" , "sabbnet")
      appScript.setAttribute("onload" , "initSdk('Bots')");
      document.body.appendChild(appScript);

    }
  };
  const MenuItems = () => {

    return (
      <>
        {items.map((item, i) =>
          <CustomNavLinkSmall key={i} onClick={() => window.open(item.url, "_blank")} isArabic={languageCheck.language}>
            <Span isArabic={languageCheck.language}>{props.t(item.title)}</Span>
          </CustomNavLinkSmall>
        )}
        <Section isArabic={languageCheck.language} onClick={toggleClickHandler}>
        </Section>
      </>
    );
  };

  const MenuItemsMobile = () => {
    return (
      <>
        <TopnavResponsive isArabic={languageCheck.language}>
          <ul>
            {items.map((item, i) =>
                <li key={i}>
                  <a onClick={() => window.open(item.url, "_blank")}>
                    <strong>{props.t(item.title)}</strong></a>
                </li>
            )}
          </ul>
        </TopnavResponsive>
      </>
    );
  };

  return (
    <HeaderSection>
      <Grid container>
        <Grid item lg={12} xs={12}>
          <MainTopUtility>
            <MainTopUtilityRow>
             
            </MainTopUtilityRow>
          </MainTopUtility>
        </Grid>
        <Grid item lg={12} xs={12} style={{ paddingTop: "50px" }}>
          <MainTopNavigation>
            <Grid container spacing={4}>
              <Grid item lg={2} xs={3}>
                <LogoContainer isArabic={languageCheck.language}>
                  <SvgIcon src="sablogo.gif" width="100%" height="35px" />
                </LogoContainer>
              </Grid>
              {!props.menuShow &&
              <Grid item lg={10} xs={9}>
                <MenuItems />                 
                <LangButton isArabic={languageCheck.language} onClick={handleChange}>
                {/* <ImgSpan><SvgIcon src={languageCheck.language ? "language_en.svg" : "language_ar.svg"} width="26px" height="20px" /></ImgSpan> */}
                {/* TODO: Implement activate localization here */}
                <SiteControls isArabic={languageCheck.language}>{props.t("Arabic")}</SiteControls>
              </LangButton>
              </Grid>
              }
              {props.menuShow &&
              <Grid item lg={10} xs={9}>                
                 <LangButton isArabic={languageCheck.language}  onClick={handleChange}>
                {/* TODO: Implement activate localization here */}
                <SiteControls isArabic={languageCheck.language}>{props.t("Arabic")}</SiteControls>
              </LangButton>
              </Grid>
              }
            </Grid>
            {!props.menuShow && <>
            {isOpen && <MenuItemsMobile />}
            </>
            }
          </MainTopNavigation>
        </Grid>
      </Grid>
    </HeaderSection>
  );
};


export default withTranslation()(Header);
